import { useEffect, useState } from "react";
import RouteModal from "../../../../Component/BasicComponents/Modal/RouteModal";
import RouteDropdown from "../../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";
import { Btn } from "../../../../AbstractElements";
import { toast } from "react-toastify";
import { useAddClassification, useUpdateClassification } from "../hooks/useClassification";


type ModalProps = {
    setIsModalOpen?: any;
    isModalOpen?: any;
    toggleModal?: any;
    title?: any;
    checkAddEditStatus?: any;
    setCheckAddEditStatus?: any;
    rowData?: any;

};
const ClassificationAddAndEditModal: React.FC<ModalProps> = ({ rowData, setIsModalOpen, isModalOpen, title, checkAddEditStatus, setCheckAddEditStatus }) => {
    const [modalValues, setModalValues] = useState<any>({
        classificationName: '',
    })
    // const { data } = useOutletTypesData({ enable: true });
    const { mutate } = useAddClassification();
    const { mutate: updateMutate } = useUpdateClassification();

    const handleClose = () => {
        setIsModalOpen(false);
        setCheckAddEditStatus('');
        setModalValues((prevState: any) => ({ ...prevState, classificationName: '' }))
    }

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!modalValues?.classificationName) {
            toast.warn("Please enter classification.");
            return;
        }
        const body:any = {
            classificationName: modalValues?.classificationName,
        };
        if (checkAddEditStatus === "Add") {
            mutate(body, {
                onSuccess: () => {
                    handleClose();
                },
            });
        } else {
            body['classificationId'] = rowData?.Id
            updateMutate(
                { body },
                {
                    onSuccess: () => {
                        handleClose();
                    },
                }
            );
        }
    };




    useEffect(() => {
        if (checkAddEditStatus === 'Edit') {
            setModalValues((prevState: any) => ({ ...prevState, classificationName: rowData?.Classification }))
        }
    }, [checkAddEditStatus])


    return (
        <RouteModal
            isOpen={isModalOpen}
            toggle={() => { setIsModalOpen(!isModalOpen); setModalValues((prevState: any) => ({ ...prevState, classificationName: '' })); }}
            title={title}
            size="md"
            content={
                <form onSubmit={handleSubmit}>
                    <div className="row mb-0 col-sm-12">
                        <CustomInput
                            placeholder="Classification Name"
                            disabled={false}
                            onChange={(e: any) => { setModalValues((prevState: any) => ({ ...prevState, classificationName: e.target.value })); }}
                            value={modalValues?.classificationName}
                            required={true}
                            label="Classification Name*"
                            style={{
                                border: "1px solid #EDEDED",
                                borderRadius: "4px",
                                padding: "10px",
                                fontSize: "14px",
                                backgroundColor: "#fff",
                            }}
                        />

                        {/* Buttons */}
                        <div className="d-flex justify-content-start gap-2">
                            <Btn
                                style={{ backgroundColor: "#43B9B2", color: "white" }}
                                type="submit"
                            >
                                {checkAddEditStatus === 'Add' ? 'Submit' : 'Update'}
                            </Btn>
                            <Btn
                                style={{
                                    backgroundColor: "#F9FAFC",
                                    color: "#000",
                                    border: "1px solid #E0E0E0",
                                }}
                                type="button"
                                onClick={() => { setIsModalOpen(false); setCheckAddEditStatus(''); setModalValues((prevState: any) => ({ ...prevState, classificationName: '' })); }}
                            >
                                Cancel
                            </Btn>
                        </div>
                    </div>
                </form>
            }
        />
    )
}

export default ClassificationAddAndEditModal;